import { Box, SxProps, Theme } from '@mui/material'

import StyledWrap from 'components/StyledWrap'
import { concatToSXProp } from 'utils/style'

interface LogoProps {
  logo: string | null
  companyName?: string
  styles?: SxProps<Theme>
}

const logoStyles: SxProps = {
  display: 'block',
  width: 'auto',
  height: 'auto',
  maxWidth: {
    xs: 'calc(100vw - 128px)',
    sm: '160px',
  },
  maxHeight: {
    xs: '40px',
    sm: '50px',
  },
  objectFit: 'contain',
}

export default function Logo({ logo, companyName, styles }: LogoProps): JSX.Element | null {
  if (logo === null) {
    return null
  }

  const altText = companyName ? `${companyName} logo` : 'Company logo'

  return (
    <StyledWrap wrapCss="display: inline-flex;" elementName="Logo">
      <Box
        className="logo"
        component="img"
        sx={concatToSXProp(styles, logoStyles)}
        src={logo}
        alt={altText}
      />
    </StyledWrap>
  )
}
